var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-list layout-padding"},[_c('m-invoices',{attrs:{"load":_vm.load,"reset-items":function () {_vm.$store.dispatch('entities/invoices/deleteAll')},"show-filters":false,"height":"calc(100vh - 450px)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }